import { useEffect, useState } from "react";
import { logError } from "shared/services/ErrorReporting";
import { toast } from "../utils/toast";

type ErrorMessage = string | Error | null | undefined | unknown;
export const useErrorToast = (error: ErrorMessage) => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const resetError = () => setErrorMessage(undefined);

  useEffect(() => {
    // surfaces the latest error passed in via argument; the message is also cleared when the toast is dismissed, so it cannot be a pure derivation
    if (error) setErrorMessage(error.toString());
  }, [error]);

  const handleError = (newError: ErrorMessage) => {
    setErrorMessage(newError?.toString());
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: resetError only clears state; the toast should fire once per error
  useEffect(() => {
    if (errorMessage) {
      logError(errorMessage);
      toast.error(errorMessage, {
        onAction: resetError,
        onAutoClose: resetError,
      });
    }
  }, [errorMessage]);

  return { handleError };
};
